import type { ComputedRef, InjectionKey } from 'vue'

export const sensitiveFieldsKey: InjectionKey<ComputedRef<Set<string>>> = Symbol('sensitiveFields')

export const isProjectSensitiveKey: InjectionKey<ComputedRef<boolean>> = Symbol('isProjectSensitive')
